<template>
  <d-confirm-modal
    :modal="modal"
    :title="
      $t('projects.change-status.title', {
        status: item.isActive
          ? $t('defaults.text.inactive').toLowerCase()
          : $t('defaults.text.active').toLowerCase(),
      })
    "
    :text="
      $t('projects.change-status.text', {
        status: item.isActive
          ? $t('defaults.text.inactive').toLowerCase()
          : $t('defaults.text.active').toLowerCase(),
      })
    "
    :submitButtonText="
      item.isActive
        ? $t('defaults.button.deactivate')
        : $t('defaults.button.activate')
    "
    :submitButtonColor="item.isActive ? 'error' : 'success'"
    :isSubmitting="isSubmitting"
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
  ></d-confirm-modal>
</template>

<script>
import { changeProjectStatus } from "@/services/project";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async handleSubmitModal() {
      try {
        this.isSubmitting = true;
        await changeProjectStatus({
          id: this.item.id,
          isActive: !this.item.isActive,
        });
        this.$eventBus.$emit("notification", {
          type: "success",
          message: this.$t("projects.change-status.alert.changed", {
            status: this.item.isActive
              ? this.$t("defaults.text.inactive").toLowerCase()
              : this.$t("defaults.text.active").toLowerCase(),
          }),
        });
        this.$emit("submitModal");
        this.handleCloseModal();
      } catch {
        this.$eventBus.$emit("notification", {
          type: "error",
          message: this.$t("defaults.text.request-error"),
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    handleCloseModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
